import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/guofeng/banner.png'
import navColor from '../../assets/guofeng/nav/color.png'
import navBg from '../../assets/guofeng/nav/nav_bg.png'

import calcRemFn from '../calcRem'

const PROD_ID = '95091'

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(134),
    backgroundImage: `url(${navColor})`,
  },
  navCtn: {
    height: calcRemFn(134),
    backgroundImage: `url(${navBg})`,
  },
  topBtnLayout: {
    alignItems: 'center',
    padding: `${calcRemFn(12)} ${calcRemFn(68)} 0 ${calcRemFn(68)}`,
  },
  topBtnBaseCss: {
    width: calcRemFn(50),
    height: calcRemFn(52.5),
    opacity: 1,
  },
  topBtnBaseCss2: {
    opacity: 0
  },
  bottomBtnLayout: {
    padding: `0 ${calcRemFn(24)} 0 ${calcRemFn(25)}`,
    marginTop: calcRemFn(-2)
  },
  bottomBtnBaseCss: {
    width: calcRemFn(47.5),
    height: calcRemFn(27),
    opacity: 1
  },
  bottomBtnBaseCss2: {
    opacity: 0
  }
}


const navData = {
  guofengSpec: true,
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
    },
    {
      key: 'top2',
      show: true,
    },
    {
      key: 'top3',
      show: true,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
      },
      {
        key: '_i2',
        show: true,
      },
      {
        key: '_i3',
        show: true,
      },
      {
        key: '_i4',
        show: true,
      },
    ],
    top2: [
      {
        key: '_i1',
        show: true,
      }
    ],
    top3: [
      {
        key: '_i1',
        show: true,
      }
    ],
  },
}

navData.top = navData.top.map((item, index) => {
  item.img = ''
  item.img_actived = require(`../../assets/guofeng/nav/far${index + 1}_active.png`)
  return item
})


navData.bottom.top1 = navData.bottom.top1.map((item, index) => {
  item.img = ''
  item.img_actived = require(`../../assets/guofeng/nav/son${index + 1}_active.png`)
  return item
})

navData.bottom.top2[0].img = ''
navData.bottom.top3[0].img = ''

navData.bottom.top2[0].img_actived = require(`../../assets/guofeng/nav/son5_active.png`)
navData.bottom.top3[0].img_actived = require(`../../assets/guofeng/nav/son6_active.png`)

const pictureList = [
  {
    id: PROD_ID,
    type: 'blue',
    ref: 'top1_i1',
    farName: 'top1',
    sonName: '_i1',
    son: [],
    name: '唐-长乐'
  },
  {
    id: PROD_ID,
    type: 'blue',
    ref: 'top1_i2',
    farName: 'top1',
    sonName: '_i2',
    son: [],
    name: '唐-敦煌'
  },
  {
    id: PROD_ID,
    type: 'blue',
    ref: 'top1_i3',
    farName: 'top1',
    sonName: '_i3',
    son: [],
    name: '唐-锦绣'
  },
  {
    id: PROD_ID,
    type: 'blue',
    ref: 'top1_i4',
    farName: 'top1',
    sonName: '_i4',
    son: [],
    name: '唐-夜宴'
  },
  {
    id: PROD_ID,
    type: 'blue',
    ref: 'top2_i1',
    farName: 'top2',
    sonName: '_i1',
    son: [],
    name: '宋-子衿'
  },
  {
    id: PROD_ID,
    type: 'blue',
    ref: 'top3_i1',
    farName: 'top3',
    sonName: '_i1',
    son: [],
    name: '明-颜华'
  },
]

pictureList.forEach((item, index) => {
  if (item.farName === 'top1') {
    item.son.push(require(`../../assets/guofeng/ctn/1_${index + 1}.png`))
  } else if (item.farName === 'top2') {
    item.son.push(require(`../../assets/guofeng/ctn/2_1.png`))
  } else if (item.farName === 'top3') {
    item.son.push(require(`../../assets/guofeng/ctn/3_1.png`))
  }
})
const pictures = pictureList

const topDiff = {
  firstSon: '_i1',
  top1_i1: 10,
  top1_i3: 10,
  top1_i4: 10,
  top2_i1: 22,
  top3_i1: 11,
}

export default {
  title: '2021国风照--初见千年霓裳梦',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff
}
